<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading) {
  <div>
    <ziro-self-serve-user-details-back
      [link]="'/self-serve/user/' + user?.ref.username"
    ></ziro-self-serve-user-details-back>
    <ziro-self-serve-user-details-header
      [heading]="'tkey;self_serve.phone.buttons.header' | translate"
      [headingDataAutomation]="'self-server-user-details-deskphone-header'"
    ></ziro-self-serve-user-details-header>
    <div class="col-md-10 offset-md-1">
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="fw-bolder mb-2">
            {{ 'tkey;shared.device.phone.phone_buttons.instruction_card.header' | translate }}
          </h3>
          <div [innerHTML]="'tkey;shared.device.phone.phone_buttons.instruction_card.text' | escapeHtml"></div>
          <strong [ngClass]="ziroIcons.TOOLTIP">
            {{ 'tkey;shared.device.phone.phone_buttons.instruction_card.footer' | translate }}
          </strong>
        </div>
      </div>
      <ziro-phone-buttons
        [isPending]="isPending"
        [userMode]="userMode"
        [global360View]="selfServe360View"
        [serverId]="cucmServerId"
        [isEnhancedLineModeOn]="isDisplayEnhancedLineMode"
        [ngClass]="{ 'phone-buttons--loaded': !isLoading, 'pointer-none': isPending }"
      ></ziro-phone-buttons>
    </div>
  </div>
}
